import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
    FormComponent,
    IFormDialogData,
} from "src/app/shared/form/form.component";
import { LocationGroup } from "src/app/models/locationGroup.model";
import { forkJoin } from "rxjs";
import { TextFormField } from "src/app/shared/form/formField.model";
import nameOf from "src/app/shared/form/nameOf.helper";
import { LocationGroupService } from "src/app/services/locationGroup.service";

@Component({
  standalone: false,
    selector: "app-location-group-dialog",
    templateUrl: "./../../shared/form/form.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./../../shared/form/form.component.scss"],
})
export class LocationGroupDialog
    extends FormComponent<LocationGroup>
    implements OnInit
{
    constructor(
        dialogRef: MatDialogRef<LocationGroupDialog>,
        @Inject(MAT_DIALOG_DATA) public data: IFormDialogData,
        locationGroupService: LocationGroupService,
        protected injector: Injector,
    ) {
        super(
            dialogRef,
            locationGroupService,
            data,
            "Location Groups",
            injector,
        );
    }

    ngOnInit() {
        forkJoin({
            entity: this.getEntity(),
        }).subscribe(
            (result) => {
                this.entity = result.entity;
                this.initFields();
                this.isFormLoading = false;
            },
            (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        );
    }

    getNewObject(): LocationGroup {
        return new LocationGroup();
    }

    onBeforeSave(model: LocationGroup): void {}

    validate(): boolean {
        return true;
    }

    initFields() {
        this.fields = [
            new TextFormField({
                property: nameOf<LocationGroup>((x) => x.name),
                name: "Location Group Name",
            }),
        ];
    }
}
